export interface Option {
  label: string;
  value: string;
}

export type Noop = () => void;

export interface Datum {
  type: string;
  id: string;
  name?: string;
}

export interface DataObj {
  data: Datum[];
}

export interface Base<Attribute, Relationship> {
  type: string;
  id: string;
  attributes: Attribute;
  relationships: Relationship;
}

export enum Phase {
  A = 'A',
  B = 'B',
  C = 'C',
}

export enum Polarity {
  Default = 'default',
  Reversed = 'reversed',
}

export enum PolarityLabel {
  Default = 'Default',
  Reversed = 'Reversed',
}

export enum FetchStatus {
  Idle = 'idle',
  Loading = 'loading',
  Failed = 'failed',
}

export enum SpinnerArea {
  Global = 'global',
  Building = 'building',
  FullPanel = 'fullPanel',
  Panel = 'panel',
  Dropdown = 'dropdown',
  /**
   * None is used to hide spinner and reduce requestCount
   */
  None = 'none',
}
